export const categories = ["Build", "Mood", "Race"];

export const wares = ["Item Condition", "Goods and Services"];

export const promptsCat = [
  [
    "averagely built",
    "short",
    "tall",
    "burly",
    "skinny",
    "slender",
    "towering",
    "athletic",
    "buff",
    "ripped",
    "chunky",
    "large",
    "tiny",
    "small",
    "long-legged",
    "thick",
    "THICCCCCCC",
    "bow-legged",
    "stout",
    "knock-kneed",
    "shapely",
    "ample",
    "barrel-chested",
    "potbellied",
    "bony",
    "brisk",
    "bulbous",
    "busty",
    "androgynous",
    "buxom",
    "colossal",
    "curvy",
    "dainty",
    "delicate",
    "drooping",
    "frail",
    "graceful",
    "herculean",
    "hulking",
    "humpbacked",
    "husky",
    "lanky",
    "limber",
    "lithe",
    "nimble",
    "petite",
    "plump",
    "portly",
    "pudgy",
    "puny",
    "rotund",
    "scrawny",
    "shrimpy",
    "shrunken",
    "shriveled",
    "sinewy",
    "slinky",
    "spry",
    "stocky",
    "strapping",
    "supple",
    "toned",
    "tubby",
    "wide",
    "willowy",
    "wiry",
    "withered",
    "wobbly",
  ],
  [
    "annoyed",
    "irritable",
    "voluptuous",
    "happy",
    "cowardly",
    "busy",
    "charming",
    "flirty",
    "clumsy",
    "confident",
    "demanding",
    "disrespectful",
    "respectful",
    "dull",
    "gentle",
    "gloomy",
    "honest",
    "humorous",
    "immature",
    "intelligent",
    "loud",
    "mean",
    "mysterious",
    "nosy",
    "noisy",
    "well organized",
    "chaotic",
    "messy",
    "persuasive",
    "polite",
    "rude",
    "serious",
    "shy",
    "earnest",
    "talkative",
    "timid",
    "unkind",
    "joyous",
    "relaxed",
    "easily flustered",
    "zany",
    "nerdy",
    "unamused",
    "mischievous",
    "queer",
    "frowning",
    "weary",
    "easily angered",
    "nervous",
    "excited",
    "anxious",
    "horny",
    "sweating",
    "fearful",
    "thoughtful",
    "giggling",
    "devious",
    "lying",
    "expressionless",
    "grimacing",
    "eye rolling",
    "tired looking",
    "drooling",
    "scatterbrained",
    "depressed",
    "know-it-all",
    "greedy",
    "gluttonous",
    "lazy",
    "jealous",
    "proud",
    "generous",
    "patient",
    "humble",
    "cheerful",
    "overwhelmed",
    "troubled",
    "shifty",
    "sketchy",
    "needy",
    "unpleasant",
    "argumentative",
    "sleepy",
    "drowsy",
    "boring",
    "frightening",
    "spooky",
    "sneering",
  ],
  [
    "Human",
    "Elf",
    "Dwarf",
    "Orc",
    "Dragon",
    "Giant",
    "Goblin",
    "Kobold",
    "Merfolk",
    "Nymph",
    "Satyr",
    "Troll",
    "Vampire",
    "Lizardfolk",
    "Catfolk",
    "Ghost",
    "Fairy",
    "Gryphon",
    "Gremlin",
    "Sylph",
    "Sphinx",
    "Centaur",
    "Demon",
    "Darkelf",
    "Gnome",
    "Ent",
    "Skeleton",
    "Werebeast",
    "Mimic",
    "Golem",
    //"Extraterrestrial",
    //"Android",
    "Angel",
    "Hobbit",
    "Chimaera",
    "Ghoul",
    "Imp",
    //"Phoenix",
    //"Unicorn",
    "Banshee",
    "Dryad",
    "Naga",
    "Mutant",
    "Slimefolk",
    //"Dinosaur",
    "Minotaur",
    "Undead",
    "Harpy",
    "Siren",
    "Valkyrie",
    "God/Goddess",
    //"Mech",
    //"Artificial Intelligence",
    //"Construct",
    //"Diety",
    "Tiefling",
    "Animalkin",
    "Celestial",
    "Amoeba",
    "Dhampir",
    "Grung",
    "Hobgoblin",
    "Changeling",
    "Firbolg",
    "Goliath",
    "Lich",
    "Beholder",
    "Plantkin",
    "Kenku",
    "Ratkin",
    "Fae",
    "Halfblood",
    "Halfling",
    "Huorn",
    "Wraith",
    "Wight",
    "Witch",
    "Spirit",
    "Birdkin",
    "Mushroomkin",
  ],
];

export const promptsWar = [
  [
    "slimy",
    "spooky",
    "enchanted",
    "magical",
    "high quality",
    "low quality",
    "non-magical",
    "plain",
    "strange",
    "ordinary",
    "slightly used",
    "simple",
    "holy",
    "unholy",
    "cheap",
    "expensive",
    "ancient",
    "musty",
    "fragrant",
    "forbidden",
    "counterfeit",
    "invisible",
    "exotic",
    "shadowy",
    "imported",
    "locally produced",
    "organic",
    "artificial",
    "mysterious",
    "pricey",
    "adequately priced",
    "dangerous",
    "award winning",
    "oversized",
    "impressive",
    "disappointing",
    "miniature",
    "secondhand",
    "ridiculous",
    "lovely",
    "suspicious",
    "sticky",
    "smelly",
    "dirty",
    "clean",
    "cursed",
    "questionable",
    "custom",
  ],
  [
    "food",
    "cheese",
    "vegetables",
    "meats",
    "fish",
    "weapons",
    "armor",
    "shields",
    "clothing and fabrics",
    "general goods",
    "books and scrolls",
    "alchemic goods",
    "magic items",
    "magical services",
    "fossils",
    "odds and ends",
    "stolen goods",
    "artifacts",
    "healing crystals",
    "occult items",
    "pets",
    "jewelry",
    "quest items",
    "blacksmithing services",
    "escort services",
    "mercinary services",
    "brews and potions",
    "paintings",
    "baked goods",
    "herbs and spices",
    "farm animals",
    "treasures",
    "gems and minerals",
    "boats and ships",
    "maps",
    "groceries",
    "furs and venison",
    "traps and bombs",
    "funeral services",
    "moonshine",
    "interpreting services",
    "information",
    "trinkets and baubles",
    "legal services",
    "forging services",
    "cartography services",
    "carriage transport",
    "portals",
    "instruments",
    "tarot readings",
    "tattoos",
    "druidic services",
    "paraphernalia",
    "medicine",
    "secrets",
    "tales and stories",
    "capes, coats and cloaks",
    "prosthetics",
    "bodyparts",
    "bottomless bags",
    "wands",
    "ingredients",
    "hair dyes",
    "calendars",
    "toys",
    "lights and lamps",
    "perfumes",
    "brooms",
    "furniture",
    "marbles",
    "pet rocks",
    "prophecies",
    "skulls",
    "insects",
    "snail shells",
    "seashells",
    "candles",
    "magnifiers",
    "glass lenses",
    "glass eyes",
    "tobacco",
    "boots",
    "love potions",
    "dolls",
    "training dummies",
    "mementos",
    "powders and tinctures",
    "hats",
    "masks",
    "rings",
    "houseplants",
    "snacks",
    "musical performances",
    "songs",
    "poems",
    "teeth",
    "piercings",
    "beard oils",
    "flowers",
    "cookies",
    "cutlery",
    "lucky charms",
    "voodoo dolls",
    "horcruxes",
    "chess pieces",
    "costumes",
    "disguises",
    "backpack upgrades",
    "snake poisons",
    "dragon scales",
    "craft beers",
    "wigs and beards",
    "tankards",
  ],
];
